export default "__VITE_ASSET__CcTGSuQ3__"